import HttpService from "./HttpService";

const getApprovals = (status, processType) => {
  let url = "/approvals";
  const params = [];
  if (status) params.push(`status=${status}`);
  if (processType) params.push(`processType=${processType}`);
  
  if (params.length > 0) {
    url += "?" + params.join("&");
  }

  return HttpService.getAxiosClient().get(window.API_URL + url);
};

const decideRequest = (id, decision) => {
  return HttpService.getAxiosClient().post(
    window.API_URL + `/approvals/${id}/decide`,
    decision
  );
};

const getApprovalContext = (id) => {
  return HttpService.getAxiosClient().get(window.API_URL + `/approvals/${id}/context`);
};

const ApprovalService = {
  getApprovals,
  decideRequest,
  getApprovalContext,
};

export default ApprovalService;
